import { render, staticRenderFns } from "./PaymentPixDetails.vue?vue&type=template&id=054fdcac&scoped=true&"
import script from "./PaymentPixDetails.vue?vue&type=script&lang=js&"
export * from "./PaymentPixDetails.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPixDetails.vue?vue&type=style&index=0&id=054fdcac&scoped=true&lang=css&"
import style1 from "./PaymentPixDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054fdcac",
  null
  
)

export default component.exports